import type { IconProps } from './types'

export const RequestIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M8 4.75H16L19.25 8V19.25C19.25 20.2165 18.4665 21 17.5 21H8C6.75736 21 5.75 19.9926 5.75 18.75V7C5.75 5.75736 6.75736 4.75 8 4.75Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M15.5 4.75V8.5H19.25" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 12H15.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9 15.5H13.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}
